export const DATE_FORMATS = {
    'DD-MM-YYYY': 'DD-MM-YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'YYYY-MM-DD': 'YYYY-MM-DD',
};
export const OPTION_CHILD_SEPARATOR = ',';
export const CREATE_ORDER_SKELETON_TEMPLATE = {
    package: { type: "", width: "25%" },
    item: { type: "input", width: "100%", height: "50px" },
    addon: { type: "", width: "25%" },
    meal: { type: "", width: "25%" },
    comment: { type: "input", width: "100%", height: "100px" },
    discountText: { type: "", width: "25%" },
    discount: { type: "input", width: "100%", height: "20px" },
    entitlementText: { type: "", width: "25%" },
    entitlement: { type: "input", width: "100%", height: "20px" },
};
export const CREATE_TICKET_SKELETON_TEMPLATE = {
    ticket: { type: "card", width: "300", height: "300" },
    ticketName: { type: "input", width: "100%", height: "50px" },
    ticketPrice: { type: "input", width: "100%", height: "20px" },
    ticketDescription: { type: "input", width: "100%", height: "100px" },
};
export const TOS_API_URL = 'https://playmas.coaxcloud.com/wp-json/wp/v2/pages/127';
export const VITE_BACKEND_API = 'https://dusty-foul-amount.glitch.me';
export const VITE_CLIENT_ID = 'playmastechitest';
export const PAYMENT_PROCESSORS = [
    { label: 'Mango Pay', value: 'mangopay' },
    { label: 'PayPal', value: 'paypal' },
    { label: 'Stripe', value: 'stripe' },
];
export const PAYMENT_TYPES = {
    FULL: 'full',
    CUSTOM: 'custom',
    MINIMUM: 'minimum',
};
